import { useEffect, useState } from "react";
import { get_tipos_notificaciones } from "../../../actions";
import { SelectUi } from "../../ui";

export const TiposNotificacionSelect = ({ ...props }) => {
  const [opciones, setOpciones] = useState([]);

  useEffect(() => {
    const OnLoad = async () => {
      const datos = await get_tipos_notificaciones();
      setOpciones(datos);
    };
    OnLoad();
  }, []);

  return <SelectUi data={opciones} {...props} />;
};
